import { CSSObjectWithLabel } from "react-select";

const MOBILE_SCREEN_GAP = 8;

// Keeps a react-select menu portal inside a phone screen: caps its width and pulls it left if it would overflow.
export const getMobileMenuPortalStyles = (
  base: CSSObjectWithLabel,
  menuWidth: number
): CSSObjectWithLabel => {
  const width = Math.min(menuWidth, window.innerWidth - MOBILE_SCREEN_GAP * 2);
  const left = typeof base.left === "number" ? base.left : MOBILE_SCREEN_GAP;
  const maxLeft = window.innerWidth - width - MOBILE_SCREEN_GAP;

  return { ...base, width, left: Math.min(left, maxLeft) };
};
